import { NoAdsCompanyIcon } from '@/components/ui/Icons/Icons';
import { Typography } from '@/components/ui/Typography/Typography.styles';

import * as S from '../NoAds.styles';
import { Props } from '../NoAds.types';

export const NoAdsSimilarVacancies: Props = ({ t, isDark }) => {
  const icon = <NoAdsCompanyIcon isDark={isDark} />;

  return (
    <S.NoAdsWrapper $paddingBlock="20px" data-testid="no-ads-similar-vacancies">
      <S.IllustrationWrapper>{icon}</S.IllustrationWrapper>
      <S.TextWrapper>
        <Typography variant="h0">
          {t('NoAds.similar_vacancies.title')}
        </Typography>
        <Typography variant="body2">
          {t('NoAds.similar_vacancies.subtitle')}
        </Typography>
      </S.TextWrapper>
    </S.NoAdsWrapper>
  );
};
